import React from 'react';
import { features } from '../data/mock';

const Features = () => {
  return (
    <section className="relative py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              className="group relative rounded-2xl border border-cream/10 bg-[#120e0c] p-7 hover:border-cream/25 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="flex flex-col h-full min-h-[200px]">
                <div className="h-px w-10 bg-cream/30 group-hover:w-16 group-hover:bg-cream transition-all duration-500" />
                <h3 className="mt-5 font-display text-[26px] md:text-[28px] text-cream leading-tight">{f.title}</h3>
                <p className="mt-3 text-[14px] text-cream-soft leading-relaxed">{f.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
